import { render } from "./ExpenseReceiptCreateBottomSection.vue?vue&type=template&id=523cb274&scoped=true"
import script from "./ExpenseReceiptCreateBottomSection.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptCreateBottomSection.vue?vue&type=script&lang=js"

import "./ExpenseReceiptCreateBottomSection.vue?vue&type=style&index=0&id=523cb274&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523cb274"]])

export default __exports__